// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce8f7a92","239":"4f5d648b","455":"e4c5ca8c","488":"86d3ce55"}[chunkId] + ".chunk.js";
};